import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { ReactSelectStyle } from "../Style/ReactSelect";
import {
  DOUBLE_OPT_IN_MANDATORY_LIST,
  DOUBLE_OPT_IN_METHOD,
  LOCAL_NAME_LIST,
  KANJI_KATAKANA_LIST,
  PAGE_STATUS_LANDING,
} from "../Utils/Constants";
import { fetchApi } from "../Utils/Fetch";
import BrowserDatePicker from "./BrowserDatePicker";
//import MobileDatePicker from "./MobileDatePicker";
import Checkbox from "@mui/material/Checkbox";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import "../App.css";
import { useStoreCountry } from "../Contexts/StoreCountryContext";
var Markdown = require("react-remarkable");

// Query to get the URL
const getQueryParams = (query) => {
  return query
    ? JSON.parse('{"' + query.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value) })
    : {};
};


const MainForm = ({
  modal,
  setModal,
  consentModal,
  setConsentModal,
  uid,
  setPageStatus,
  setDoubleOptInMethod,
}) => {
  const { t, i18n } = useTranslation();
  const titleRef = useRef(null);
  const firstNameRef = useRef(null);
  const familyNameRef = useRef(null);
  const inglesinaStoreRef = useRef(null);
  const productNameRef = useRef(null);
  const serialNumberRef = useRef(null);
  const dayOfBirthRef = useRef(null);
  const monthOfBirthRef = useRef(null);
  const genderRef = useRef(null);
  const nationalityRef = useRef(null);
  const cityRef = useRef(null);
  const stateCountyRef = useRef(null);
  const countryRef = useRef(null);
  const addressRef = useRef(null);
  const zipcodeRef = useRef(null);
  const { store } = useStoreCountry();
  const [selectsOptions, setSelectsOptions] = useState({});
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    firstNameLocal: "",
    lastNameLocal: "",
    inglesina_store: "",
    dayOfBirth: "",
    monthOfBirth: "",
    yearOfBirth: "",
    gender: "",
    prefix: "",
    phone: "",
    email: "",
    address: "",
    building_apartment_villa: "",
    zipCode: "",
    city: "",
    product_name: "",
    serial_number: "",
    stateCounty: "",
    country: "",
    consentOne: false,
    consentTwo: null,
    consentThree: false,
    consentFour: false,
  });
  const [autoSubmit, setAutoSubmit] = useState(false);
  const [isUnderage, setIsUnderage] = useState(false);

  const onFirstNameChange = (e) => {
    setFormData((prev) => ({ ...prev, firstName: e.target.value }));
    setErrors((prev) => ({ ...prev, firstName: undefined }));
  };

  const onLastNameChange = (e) => {
    setFormData((prev) => ({ ...prev, lastName: e.target.value }));
    setErrors((prev) => ({ ...prev, lastName: undefined }));
  };

  const onTitleChange = (option) => {
    if (option) {
      var targetGender = selectsOptions.gender.find(
        (o) => o.id === option.genderId
      );
      setFormData((prev) => ({ ...prev, title: option, gender: targetGender }));
      setErrors((prev) => ({ ...prev, title: undefined, gender: undefined }));
    } else {
      setFormData((prev) => ({ ...prev, title: null }));
    }
  };

  const onGenderChange = (option) => {
    if (option) {
      setFormData((prev) => ({ ...prev, gender: option }));
      if (
        option.id !== "-" &&
        formData.title?.genderId !== "-" &&
        option.id !== formData.title?.genderId
      ) {
        setFormData((prev) => ({ ...prev, title: null }));
      }
      setErrors((prev) => ({ ...prev, gender: undefined }));
    } else {
      setFormData((prev) => ({ ...prev, gender: null }));
    }
  };

  const onPrefixChange = (option) => {
    setFormData((prev) => ({ ...prev, prefix: option }));
  };

  const onStateCountyChange = (option) => {
    setFormData((prev) => ({ ...prev, stateCounty: option }));
    setErrors((prev) => ({ ...prev, stateCounty: undefined }));
  };

  const onCountryChange = (option) => {
    if (option) {
      setFormData((prev) => ({ ...prev, country: option }));
      setErrors((prev) => ({ ...prev, country: undefined }));
      if (option.id !== "US" && option.id !== "CA") {
        setFormData((prev) => ({ ...prev, stateCounty: "" }));
        setErrors((prev) => ({ ...prev, stateCounty: undefined }));
      }
    } else {
      setFormData((prev) => ({ ...prev, country: null }));
    }
  };

  const onNationalityChange = (option) => {
    if (option) {
      var targetPrefix = selectsOptions.prefix.find(
        (o) => o.id === option.prefixId
      );
      var country = selectsOptions.country.find((c) => c.id === option.id);
      setFormData((prev) => ({
        ...prev,
        nationality: option,
        country: country,
        prefix: targetPrefix,
      }));
      setErrors((prev) => ({ ...prev, nationality: undefined }));
      if (option.id !== "US" && option.id !== "CA")
        setFormData((prev) => ({ ...prev, stateCounty: "" }));
    } else {
      setFormData((prev) => ({ ...prev, nationality: null }));
    }
  };

  const onProductChange = (option) => {
    setFormData((prev) => ({ ...prev, product_name: option }));
    setErrors((prev) => ({ ...prev, product_name: undefined }));
  };

  const onInglesinaStoreChange = (option) => {
    if (option) {
      setFormData((prev) => ({ ...prev, inglesina_store: option }));
      setErrors((prev) => ({ ...prev, inglesina_store: undefined }));
    } else {
      setFormData((prev) => ({ ...prev, inglesina_store: null }));
    }
  };

  const onClickPrivacy = (e) => {
    if (e.target.localName !== "strong") return;
    setModal({
      ...modal,
      title: t("privacy"),
      body: t("retro"),
      size: "modal-xl",
      show: true,
    });
  };

  const onClickPassegginiWarranty = (e) => {
    if (e.target.localName !== "strong") return;

    setModal({
      ...modal,
      title: t("warranty"),
      body: t("passeggini_text_1_retro"),
      size: "modal-xl",
      show: true,
    });
  };
  
  const downloadFile = (e) => {
    if (e.target.localName !== "strong") return;

    const uri = "/assets/China_CGI.pdf";
    const name = "policy_info.pdf";
    const link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const submitForm = async (evt) => {
    evt.preventDefault();
    await internalSubmitForm();
  };

  // Variable to set the visibleness
  const [isVisible, setIsVisible] = useState(false);

  const queryParams = getQueryParams(window.location.search.substring(1));

  const internalSubmitForm = async () => {
    var validation = {};

    const currentUrl = window.location.href;
    const skipValidation = queryParams.uid === "inglesina" || queryParams.uid === "inglesina-eu" || queryParams.uid === "inglesina-us";
    if (!formData.phone && !formData.email) {
      setModal({
        ...modal,
        title: t("missing_contact_details"),
        body: t("missing_phone_or_email"),
        size: "modal-md",
        show: true,
      });
      return;
    }
    if (!formData.country) {
      validation.country = "required";
      countryRef.current.focus();
    }
    if (formData.country?.id === "US" || formData.country?.id === "CA")
      if (!formData.stateCounty) {
        validation.stateCounty = "required";
        stateCountyRef.current.focus();
      }
    if (!skipValidation && !formData.nationality) {
      validation.nationality = "required";
      nationalityRef.current.focus();
    }
    if (!skipValidation && !formData.gender) {
      validation.gender = "required";
      genderRef.current.focus();
    }
    if (!isMobile) {
      if (!formData.monthOfBirth) {
        validation.monthOfBirth = "required";
        monthOfBirthRef.current.focus();
      }
      if (!formData.dayOfBirth) {
        validation.dayOfBirth = "required";
        dayOfBirthRef.current.focus();
      }
    } else {
      if (!formData.dayOfBirth) {
        validation.dayOfBirth = "required";
        //dayOfBirthRef.current.focus();
      }
    }
    if (!formData.lastName) {
      validation.lastName = "required";
      familyNameRef.current.focus();
    }
    if (!formData.firstName) {
      validation.firstName = "required";
      firstNameRef.current.focus();
    }
    if (!skipValidation && !formData.title) {
      validation.title = "required";
      titleRef.current.focus();
    }
    if (skipValidation && !formData.address) {
      validation.address = "required";
      addressRef.current.focus();
    }
    if (skipValidation) {
      if (!formData.serial_number) {
        validation.serial_number = "required";
        serialNumberRef.current.focus();
      } else {
        // List of valid serial numbers
        const validSerialNumbers = [
          'INAL2506984',
          'INAL2506985',
          'INAL2506986',
          'INAL2506987',
          'INAL2507164',
          'INAL2507165',
          'INAL2507166',
          'INGN2504405',
          'INGN2504406',
          'INGN2504407'
        ];
        
        // First validate format
        const serialNumberPattern = /^IN(AL|GN)[0-9]{7}$/;
        const isValidFormat = serialNumberPattern.test(formData.serial_number);
        
        // Then check if it's in the allowed list
        const isValidSerialNumber = validSerialNumbers.includes(formData.serial_number);
        if (!isValidFormat || !isValidSerialNumber) {
          validation.serial_number = "invalid_format";
          serialNumberRef.current.focus();
        }
      }
    }
    if (skipValidation && !formData.zipCode) {
      validation.zipCode = "required";
      zipcodeRef.current.focus();
    }
    if (skipValidation && !formData.city) {
      validation.city = "required";
      cityRef.current.focus();
    }
    if (skipValidation && !formData.product_name) {
      validation.product_name = "required";
      productNameRef.current.focus();
    }
    if (skipValidation && !formData.inglesina_store) {
      validation.inglesina_store = "required";
      inglesinaStoreRef.current.focus();
    }


    setErrors(validation);

    if (Object.keys(validation).length !== 0) {
      return;
    }

    if (isUnderage) {
      return;
    }

    if (
      (formData.consentOne === false || formData.consentFour === false) &&
      formData.consentTwo === null &&
      queryParams.uid !== "inglesina-eu" && queryParams.uid !== "inglesina-us" && queryParams.uid !== "inglesina"
    ) {
      setConsentModal({
        ...consentModal,
        show: true,
        formData: formData,
        setFormData: setFormData,
        autoSubmit: autoSubmit,
        setAutoSubmit: setAutoSubmit,
      });
      return;
    }

    if (formData.consentOne === true && formData.consentFour === true) {
      formData.consentTwo = true;
    }

    var postData = {
      uid: uid,
      title: formData.title?.name,
      firstName: formData.firstName,
      lastName: formData.lastName,
      firstNameLocal: formData.firstNameLocal,
      lastNameLocal: formData.lastNameLocal,
      inglesina_store: formData.inglesina_store?.id,
      dayOfBirth: formData.dayOfBirth?.id,
      monthOfBirth: formData.monthOfBirth?.id,
      yearOfBirth: formData.yearOfBirth?.id,
      nationality: formData.nationality?.id,
      gender: formData.gender?.id,
      prefix: formData.prefix?.id,
      phone: formData.phone,
      email: formData.email,
      address: formData.address,
      building_apartment_villa: formData.building_apartment_villa,
      zipCode: formData.zipCode,
      city: formData.city,
      product_name: formData.product_name?.id,
      serial_number: formData.serial_number,
      stateCounty: formData.stateCounty?.id
        ? formData.stateCounty.id.split("-")[1]
        : "",
      country: formData.country?.id,
      language: i18n.resolvedLanguage,
      store: store,
      consentOne: formData.consentOne,
      consentTwo: formData.consentTwo,
      consentThree: formData.consentThree,
      consentFour: formData.consentFour,
    };

    setPageStatus(PAGE_STATUS_LANDING.PENDING);

    try {
      await fetchApi("form", { method: "POST", body: postData });
      if (formData.email || (formData.phone && formData.email))
        setDoubleOptInMethod(DOUBLE_OPT_IN_METHOD.EMAIL);
      else if (formData.phone) setDoubleOptInMethod(DOUBLE_OPT_IN_METHOD.PHONE);
      else throw { message: "email and phone are null" };
      console.log(postData.store);
      if (!DOUBLE_OPT_IN_MANDATORY_LIST.includes(postData.store)) {
        setPageStatus(PAGE_STATUS_LANDING.ALREADY_DOUBLE_OPT_IN);
      } else {
        setPageStatus(PAGE_STATUS_LANDING.COMPLETED);
      }
    } catch (err) {
      console.error(err);
      setPageStatus(PAGE_STATUS_LANDING.VALID_UID);
      setModal({
        ...modal,
        title: t("there_was_an_error"),
        body: t("a_communication_error_occurred"),
        size: "modal-md",
        show: true,
      });
    }
  };

  // useEffect to set the visibility according to the URL
  useEffect(() => {
    if (queryParams.uid === "inglesina" || queryParams.uid === "inglesina-eu" || queryParams.uid === "inglesina-us") {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, []);

  useEffect(() => {
    if (autoSubmit === true) {
      internalSubmitForm();
    }
  }, [autoSubmit]);

  useEffect(() => {
    async function fetchSelects() {
      try {
        var selectsOptions = await fetchApi("selects");
        selectsOptions.country.sort((a, b) => a.name.localeCompare(b.name));
        selectsOptions.nationality.sort((a, b) => a.name.localeCompare(b.name));
        selectsOptions.prefix.sort((a, b) => a.name.localeCompare(b.name));
        selectsOptions.region.sort((a, b) => a.name.localeCompare(b.name));
        selectsOptions.inglesina_product_name.sort((a, b) => a.name.localeCompare(b.name));
        selectsOptions.inglesina_store_list.sort((a, b) => a.name.localeCompare(b.name));
        setSelectsOptions(selectsOptions);
      } catch (err) {
        console.error(err);
      }
    }
    fetchSelects();
  }, [setSelectsOptions]);
  return (
    <div>
      <form id="main-form" className="container" onSubmit={submitForm}>
        {isVisible && (
          <>
            <div className="d-flex flex-row justify-content-start">
              <div className="m-2">
                <label>
                  <h4 style={{ color: 'black' }}>{i18n.t("passeggini_title")}</h4>
                </label>
              </div>
            </div>
            <div className="d-flex flex-row justify-content-start">
              <div className="m-2">
                <label>
                  <Markdown>{i18n.t("passeggini_paragraph")}</Markdown>
                </label>
              </div>
            </div>
          </>
        )}
        <div className="d-flex mx-2" style={{ marginBottom: "15px" }}>
          <p className="fst-italic">{`* ${i18n.t("required")}`}</p>
        </div>
        <div className="flex-container d-flex justify-content-center align-items-md-end">
          {!isVisible && (
            <div className="m-2" style={{ flex: 1 }}>
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="title">{`* ${i18n.t("title")}`}</label>
              <Select
                isClearable={true}
                id="title"
                placeholder=""
                onChange={onTitleChange}
                ref={titleRef}
                value={formData.title}
                getOptionLabel={(o) => o.name}
                getOptionValue={(o) => o.id}
                styles={ReactSelectStyle}
                options={
                  selectsOptions.title &&
                  selectsOptions.title.map((s) => {
                    return document.documentElement.dir === "rtl" &&
                      s.name[s.name.length - 1] === "."
                      ? {
                        id: s.id,
                        name:
                          s.name.substr(-1) + s.name.substr(0, s.name.length - 1),
                      }
                      : s;
                  })
                }
                className={`${errors.title ? "is-invalid" : ""}`}
              />
              <div className="invalid-feedback">{i18n.t("required")}</div>
            </div>
          )}
          <div className="m-2" style={{ flex: 1 }}>
            <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="first_name">{`* ${i18n.t("first_name")}`}</label>
            <input
              ref={firstNameRef}
              value={formData.firstName}
              onChange={onFirstNameChange}
              className={`form-control underline-input ${errors.firstName ? "is-invalid was-validated" : ""
                }`}
              type="text"
              id="first_name"
              name="first_name"
              placeholder=""
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            ></input>
            <div className="invalid-feedback">{i18n.t("required")}</div>
          </div>
          <div className="m-2" style={{ flex: 1 }}>
            <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="family_name">{`* ${i18n.t("family_name")}`}</label>
            <input
              ref={familyNameRef}
              value={formData.lastName}
              onChange={onLastNameChange}
              className={`form-control underline-input ${errors.lastName ? "is-invalid was-validated" : ""
                } `}
              type="text"
              id="family_name"
              name="family_name"
              placeholder=""
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            ></input>
            <div className="invalid-feedback">{i18n.t("required")}</div>
          </div>
        </div>
        {/*
        <div
          className={`flex-container d-flex justify-content-center ${KANJI_KATAKANA_LIST.includes(i18n.resolvedLanguage) ? "" : "hidden"
            }`}>
          <div className="m-2" style={{ flex: 1 }}>
            <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="katakana_family_name">{`* ${i18n.t("katakana_family_name")}`}</label>
            <input
              value={formData.lastNameLocal}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  lastNameLocal: e.target.value,
                }));
              }}
              className="underline-input form-control"
              type="text"
              id="katakana_family_name"
              name="katakana_family_name"
              placeholder=""
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            ></input>
          </div>
          <div className="m-2" style={{ flex: 1 }}>
            <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="kanji_family_name">{`* ${i18n.t("kanji_family_name")}`}</label>
            <input
              value={formData.firstNameLocal}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  firstNameLocal: e.target.value,
                }));
              }}
              className="underline-input form-control"
              type="text"
              id="kanji_family_name"
              name="kanji_family_name"
              placeholder=""
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            ></input>
          </div>
        </div>*/}


      <div
        className={`flex-container d-flex justify-content-center ${
          LOCAL_NAME_LIST.includes(i18n.resolvedLanguage) ? "" : "hidden"
        }`}>
        <div className="m-2" style={{ flex: 1 }}>
          <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="local_first_name">{`* ${i18n.t("local_first_name")}`}</label>
          <input
            value={formData.firstNameLocal}
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                firstNameLocal: e.target.value,
              }));
            }}
            className="underline-input form-control"
            type="text"
            id="local_first_name"
            name="local_first_name"
            placeholder=""
            style={{paddingLeft:"10px", paddingRight:"10px"}}
          ></input>
        </div>
        <div className="m-2" style={{ flex: 1 }}>
          <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="local_first_name">{`* ${i18n.t("local_family_name")}`}</label>
          <input
            value={formData.lastNameLocal}
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                lastNameLocal: e.target.value,
              }));
            }}
            className="underline-input form-control"
            type="text"
            id="local_family_name"
            name="local_family_name"
            placeholder=""
            style={{paddingLeft:"10px", paddingRight:"10px"}}
          ></input>
        </div>
      </div>

        {/*<div
          className={`flex-container d-flex justify-content-center ${LOCAL_NAME_LIST.includes(i18n.resolvedLanguage) ? "" : "hidden"
            }`}>
          <div className="m-2" style={{ flex: 1 }}>
            <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="local_family_and_first_name">{`* ${i18n.t("local_family_and_first_name")}`}</label>
            <input
              value={formData.firstNameLocal}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  firstNameLocal: e.target.value,
                }));
              }}
              className="underline-input form-control"
              type="text"
              id="local_family_and_first_name"
              name="local_family_and_first_name"
              placeholder=""
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            ></input>
          </div>
        </div>*/}

        {isVisible && (
          <div className="d-flex flex-container justify-content-start align-items-md-end">
            <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="product_name">* {i18n.t("product_name")}</label>
              <Select
                ref={productNameRef}
                className={`${errors.product_name ? "is-invalid" : ""}`}
                isClearable={true}
                placeholder=""
                id="product_name"
                onChange={onProductChange}
                name="product_name"
                value={formData.product_name}
                getOptionLabel={(o) => i18n.t(o.name)}
                getOptionValue={(o) => o.id}
                styles={ReactSelectStyle}
                options={selectsOptions.inglesina_product_name}
              />
              <div className="invalid-feedback">{i18n.t("required")}</div>
            </div>
            <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="serial_number">* {i18n.t("serial_number")}</label>
              <input
                ref={serialNumberRef}
                value={formData.serial_number}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  // Only allow letters and numbers
                  if (/^[A-Z0-9]*$/.test(value)) {
                    setFormData((prev) => ({ ...prev, serial_number: value }));
                    setErrors((prev) => ({ ...prev, serial_number: undefined }));
                  }
                }}
                className={`form-control underline-input ${errors.serial_number ? "is-invalid was-validated" : ""}`}
                type="text"
                id="serial_number"
                name="serial_number"
                style={{ paddingLeft: "10px", paddingRight: "10px" }}
              ></input>
              <div className="invalid-feedback">
                {errors.serial_number === "required" ? i18n.t("required") : i18n.t("invalid_serial_number_format")}
              </div>
            </div>
          </div>
        )}
        {isVisible && (
          <div className="d-flex flex-container justify-content-start align-items-md-end">
            <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="inglesina_store">* {i18n.t("inglesina_store")}</label>
              <Select
                ref={inglesinaStoreRef}
                className={`${errors.inglesina_store ? "is-invalid" : ""}`}
                isClearable={true}
                placeholder=""
                id="inglesina_store"
                onChange={onInglesinaStoreChange}
                name="inglesina_store"
                value={formData.inglesina_store}
                getOptionLabel={(o) => i18n.t(o.name)}
                getOptionValue={(o) => o.id}
                styles={ReactSelectStyle}
                options={selectsOptions.inglesina_store_list}
              />
              <div className="invalid-feedback">{i18n.t("required")}</div>
            </div>
          </div>
        )}
        {!isVisible && (
          <div className="d-flex" style={{ color: '#5B5A57', fontSize: 'smaller', marginBottom: "-15px", paddingLeft: "10px", paddingRight: "10px" }}>
            <label className="form-label">{i18n.t("day_of_birth")}:</label>
          </div>
        )}
        {isVisible && (
          <div className="d-flex" style={{ color: '#5B5A57', fontSize: 'smaller', marginBottom: "-15px", paddingLeft: "10px", paddingRight: "10px" }}>
            <label className="form-label">{i18n.t("purchase_date")}:</label>
          </div>
        )}
        <div className="d-flex">
          <BrowserDatePicker
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            dayOfBirthRef={dayOfBirthRef}
            monthOfBirthRef={monthOfBirthRef}
            setIsUnderage={setIsUnderage}
          ></BrowserDatePicker>
        </div>
        {isUnderage && (
          <div className="d-flex" style={{ color: '#9D5248', fontWeight: 'bold', fontSize: 'smaller', paddingLeft: "10px", paddingRight: "10px" }}>
            {i18n.t("age_verification_under_18")}
          </div>
        )}
        {!isVisible && (
          <div className="d-flex flex-container justify-content-start align-items-md-end">

            <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="gender">{`* ${i18n.t("gender")}`}</label>
              <Select
                className={`${errors.gender ? "is-invalid" : ""}`}
                isClearable={true}
                placeholder=""
                id="gender"
                onChange={onGenderChange}
                ref={genderRef}
                value={formData.gender}
                getOptionLabel={(o) => i18n.t(o.name)}
                getOptionValue={(o) => o.id}
                styles={ReactSelectStyle}
                options={selectsOptions.gender}
              />
              <div className="invalid-feedback">{i18n.t("required")}</div>
            </div>

            <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="nationality">{`* ${i18n.t("nationality")}`}</label>
              <Select
                className={`${errors.nationality ? "is-invalid" : ""}`}
                id="nationality"
                isClearable={true}
                placeholder=""
                onChange={onNationalityChange}
                ref={nationalityRef}
                value={formData.nationality}
                getOptionLabel={(o) => o.name}
                getOptionValue={(o) => o.id}
                styles={ReactSelectStyle}
                options={selectsOptions.nationality}
              />
              <div className="invalid-feedback">{i18n.t("required")}</div>
            </div>
          </div>
        )}

        <div className="d-flex flex-container justify-content-start align-items-md-end">
          <div
            className="d-flex justify-content-start align-items-md-end m-2"
            style={{ flex: 1 }}
          >
            <div
              className={document.documentElement.dir === "ltr" ? "me-1" : "ms-1"}
              style={{ flex: 2, fontFamily: "Optima" }}
            >
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="prefix">{i18n.t("prefix")}</label>
              <Select
                isClearable={true}
                id="prefix"
                placeholder=""
                onChange={onPrefixChange}
                value={formData.prefix}
                getOptionLabel={(o) => o.name}
                getOptionValue={(o) => o.id}
                styles={ReactSelectStyle}
                options={
                  selectsOptions.prefix &&
                  selectsOptions.prefix.map((s) => {
                    return document.documentElement.dir === "rtl" &&
                      s.name[0] === "+"
                      ? {
                        id: s.id,
                        name: s.name.substr(1, s.name.length) + s.name[0],
                      }
                      : s;
                  })
                }
              />
            </div>
            <div
              className={`${document.documentElement.dir === "ltr" ? "ms-1" : "me-1"}`}
              style={{ flex: 3, fontFamily: "Optima" }}
            >
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="phone">{i18n.t("mobile_number")}</label>
              <input
                value={formData.phone}
                onChange={(e) => {
                  setFormData((prev) => ({ ...prev, phone: e.target.value }));
                }}
                className="form-control underline-input"
                type="tel"
                id="phone"
                name="phone"
                placeholder=""
                style={{ paddingLeft: "10px", paddingRight: "10px" }}
              ></input>
            </div>
          </div>

          <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
            {isVisible && (
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="email">* {i18n.t("email_address")}</label>
            )}
            {!isVisible && (
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="email">{i18n.t("email_address")}</label>
            )}
            <input
              value={formData.email}
              onChange={(e) => {
                setFormData((prev) => ({ ...prev, email: e.target.value }));
              }}
              className="form-control underline-input"
              type="email"
              id="email"
              name="email"
              placeholder=""
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            ></input>
          </div>
        </div>

        <div className="d-flex flex-container justify-content-star align-items-md-end">
          <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
            {isVisible && (
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="address">* {i18n.t("address_line")}</label>
            )}
            {!isVisible && (
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="address">{i18n.t("address_line")}</label>
            )}
            <input
              ref={addressRef}
              value={formData.address}
              onChange={(e) => {
                setFormData((prev) => ({ ...prev, address: e.target.value }));
                setErrors((prev) => ({ ...prev, address: undefined }));
              }}
              className={`form-control underline-input ${errors.address ? "is-invalid was-validated" : ""
                } `}
              type="text"
              id="address"
              name="address"
              placeholder=""
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            ></input>
            <div className="invalid-feedback">{i18n.t("required")}</div>
          </div>
          <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
            {isVisible && (
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="zipcode">* {i18n.t("post_code")}</label>
            )}
            {!isVisible && (
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="zipcode">{i18n.t("post_code")}</label>
            )}
            <input
              ref={zipcodeRef}
              value={formData.zipCode}
              onChange={(e) => {
                setFormData((prev) => ({ ...prev, zipCode: e.target.value }));
                setErrors((prev) => ({ ...prev, zipCode: undefined }));
              }}
              className={`form-control underline-input ${errors.zipCode ? "is-invalid was-validated" : ""
                } `}
              type="text"
              id="zipcode"
              name="zipcode"
              placeholder=""
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            ></input>
            <div className="invalid-feedback">{i18n.t("required")}</div>
          </div>
        </div>

        {isVisible && (
          <div className="d-flex flex-container justify-content-start align-items-md-end">
            <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="building_apartment_villa">{i18n.t("building_apartment_villa")}</label>
              <input
                value={formData.building_apartment_villa}
                onChange={(e) => {
                  setFormData((prev) => ({ ...prev, building_apartment_villa: e.target.value }));
                }}
                className="form-control underline-input"
                type="text"
                id="building_apartment_villa"
                name="building_apartment_villa"
                placeholder=""
                style={{ paddingLeft: "10px", paddingRight: "10px" }}
              ></input>
            </div>
          </div>
        )}

        <div className="d-flex flex-container justify-content-start align-items-md-end">
          <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
            {isVisible && (
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="city">* {i18n.t("city")}</label>
            )}
            {!isVisible && (
              <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="city">{i18n.t("city")}</label>
            )}
            <input
              ref={cityRef}
              value={formData.city}
              onChange={(e) => {
                setFormData((prev) => ({ ...prev, city: e.target.value }));
                setErrors((prev) => ({ ...prev, city: undefined }));
              }}
              className={`form-control underline-input ${errors.city ? "is-invalid was-validated" : ""
                } `}
              type="text"
              id="city"
              name="city"
              placeholder=""
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            ></input>
            <div className="invalid-feedback">{i18n.t("required")}</div>
          </div>
          <div className="m-2" style={{ flex: 1, fontFamily: "Optima" }}>
            <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="statecounty">{`* ${i18n.t("statecounty")}`}</label>
            <Select
              isClearable={true}
              id="statecounty"
              placeholder=""
              className={`${errors.stateCounty ? "is-invalid" : ""}`}
              ref={stateCountyRef}
              onChange={onStateCountyChange}
              isDisabled={
                !(formData.country?.id === "US" || formData.country?.id === "CA")
              }
              value={
                formData.country?.id === "US" || formData.country?.id === "CA"
                  ? formData.stateCounty
                  : ""
              }
              getOptionLabel={(o) => o.name}
              getOptionValue={(o) => o.id}
              styles={ReactSelectStyle}
              options={selectsOptions?.region?.filter((r) =>
                r.id.startsWith(formData.country?.id)
              )}
            />
            <div className="invalid-feedback">{i18n.t("required")}</div>
          </div>
        </div>

        <div className="d-flex flex-container justify-content-start">
          <div className="m-2" style={{ flex: 1 }}>
            <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="country">{`* ${i18n.t("country")}`}</label>
            <Select
              isClearable={true}
              id="country"
              placeholder=""
              className={`${errors.country ? "is-invalid" : ""}`}
              ref={countryRef}
              onChange={onCountryChange}
              value={formData.country}
              getOptionLabel={(o) => o.name}
              getOptionValue={(o) => o.id}
              styles={ReactSelectStyle}
              options={selectsOptions.country}
            />
            <div className="invalid-feedback">{i18n.t("required")}</div>
          </div>
          <div className="m-2" style={{ flex: 1 }}></div>
        </div>

        {isVisible && (
          <>
            <div className="d-flex justify-content-start align-items-start mt-4">
              <div className="d-flex justify-content-start">
                <span className="link" onClick={onClickPassegginiWarranty}>
                  <Markdown>{i18n.t("passeggini_text_1_front")}</Markdown>
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-start align-items-start">
              <div className="d-flex justify-content-start">
                <label className="form-check-label" htmlFor="termsCheck">
                  <Markdown>{i18n.t("passeggini_text_2")}</Markdown>
                </label>
              </div>
            </div>
          </>
        )}

        {!isVisible && (
          <div className="d-flex flex-row justify-content-start">
            <div className="m-2">
              <label>
                <span className="link" onClick={onClickPrivacy}>
                  <Markdown>{i18n.t("front")}</Markdown>
                </span>
              </label>
            </div>
          </div>
        )}

        <div className="d-flex justify-content-start align-items-start">
          <div className="d-flex justify-content-start">
            <Checkbox
              checked={formData.consentOne}
              onChange={(event) => {
                setFormData((prev) => ({
                  ...prev,
                  consentOne: event.target.checked,
                }));
              }}
              sx={{
                "&.Mui-checked": {
                  color: "#9D5248",
                },
              }}
            />
          </div>
          <div className="m-2">
            <label className="form-check-label" htmlFor="termsCheck">
              <Markdown>{i18n.t("check_one")}</Markdown>
            </label>
            {isVisible && (
              <span className="link" onClick={onClickPrivacy}>
                <Markdown>{i18n.t("passeggini_privacy")}</Markdown>
              </span>
            )}
          </div>
        </div>
        {!isVisible && (
          <div className="d-flex justify-content-start align-items-start">
            <div className="d-flex justify-content-start">
              <Checkbox
                checked={formData.consentFour}
                onChange={(event) => {
                  setFormData((prev) => ({
                    ...prev,
                    consentFour: event.target.checked,
                  }));
                }}
                sx={{
                  "&.Mui-checked": {
                    color: "#9D5248",
                  },
                }}
              />
            </div>
            <div className="m-2">
              <label className="form-check-label" htmlFor="termsCheck">
                <span className="link" onClick={downloadFile}>
                  <Markdown>{i18n.t("check_four")}</Markdown>
                </span>
              </label>
            </div>
          </div>
        )}

        {store === "CN" && (
          <div className="d-flex justify-content-start align-items-start">
            <div className="d-flex justify-content-start">
              <Checkbox
                checked={formData.consentThree}
                onChange={(event) => {
                  setFormData((prev) => ({
                    ...prev,
                    consentThree: event.target.checked,
                  }));
                }}
                sx={{
                  "&.Mui-checked": {
                    color: "#9D5248",
                  },
                }}
              />
            </div>
            <div className="m-2">
              <label className="form-check-label" htmlFor="termsCheck">
                <Markdown>{i18n.t("check_three")}</Markdown>
              </label>
            </div>
          </div>
        )}

        <div className="d-flex justify-content-start align-items-start">
          <div className="m-2" style={{ color: '#5B5A57' }}>
            {i18n.t("age_verification_disclaimer")}
          </div>
        </div>

        <div className="d-flex flex-row justify-content-center">
          <div
            className="m-4"
            style={{
              alignSelf: "stretch",
              flex: "1 1 0",
              paddingLeft: 139,
              paddingRight: 139,
              borderTop: "1px #EEEAE5 solid",
              borderBottom: "1px #EEEAE5 solid",
              justifyContent: "center",
              alignItems: "center",
              display: "inline-flex",
            }}
          >
            <input
              type="submit"
              className="btn btn-loropiana btn-optima"
              value={i18n.t("confirm")}
              disabled={isUnderage}
            ></input>
          </div>
        </div>
      </form>
    </div>
  );
};

export default MainForm;